module.exports = __webpack_public_path__ + "static/media/emotional-support.217ec271.png";